var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.592773 13.2959C0.592773 6.29095 6.29192 0.591797 13.2969 0.591797C20.3018 0.591797 26.001 6.29095 26.001 13.2959C26.001 20.3008 20.3018 26 13.2969 26C6.29192 26 0.592773 20.3008 0.592773 13.2959ZM18.275 10.4137L16.179 8.31764L13.2969 11.1997L10.4148 8.31764L8.31871 10.4137L11.2008 13.2958L8.31871 16.1779L10.4148 18.274L13.2969 15.3919L16.179 18.274L18.275 16.1779L15.3929 13.2958L18.275 10.4137Z",
    fill: "#297BC7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCancel);
export default __webpack_public_path__ + "static/media/icon_cancel.55596df32ddd51d9253bbdced84f8ee9.svg";
export { ForwardRef as ReactComponent };